import $ from "jquery"
import _ from "underscore"
import makeRpcCall from "../../util/jquery_rpc"
import messageResource from "../../messageResource"
import TaskStore from "../../store/TaskStore"
import {DateFormat} from "../../date_format"
import ViewTTStore from "./ViewTTStore"
import {selectStatusIdByTask} from "../../workflowStatus/selectors"
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import PDFGenerator from "./pdf/PDFGenerator"
import {setEventPreventHidingEditTaskSlidingPanel} from "../../panels/utils"
import {getWorkflowStatuses} from "../../entities/selectors"
import {getOpenTaskId} from '../../panels/task/editPanel/selectors'
import DetailsTable from './detailsTable/DetailsTable'
import {openEditTaskPanel} from '../../panels/task/editPanel/actions'
import TimeTrackPageFeatureDiffController from '../TimeTrackPageFeatureDiffController'
import View from '../../View'
import {downloadPDF} from '../../pdf/utils'
import EditTaskPanelContainer from '../components/EditTaskPanelContainer'
import FilterController from './filter/FilterController'

class ViewTTMediator extends View {
    constructor({
        openTaskPanel = taskId => {},
    }) {
        super()

        this.actions = {
            openTaskPanel,
        }

        this.state = {
            workflowStatuses: {},
            openTaskId: null,
        }

        this.onStatePropertyChanged('openTaskId', openTaskId => {
            this.detailsTable.setState({selectedTaskId: openTaskId})
        })
    }

    init(config) {
        super.init()
        new TimeTrackPageFeatureDiffController().init()

        this._subscribeForPageEvents();
        this._setInitialSettings(config);

        this._balanceRpc = undefined;
        this._dataRpc = undefined;
        this._dataAndBalanceRpc = undefined;

        this._componentesInitialized = false;

        this.$pageWrapper = $(".pageWrapper")
        this.page = new ViewTTPage(this.$pageWrapper).init();

        this._initUsersSelector();

        if (!_.isNull(config["data"])) {
            this._prepareAndSetServerData(config["data"]);
            this._initViewTTPageComponents();
            if (ViewTTStore.getBalancesViewerConfig().displayPto || ViewTTStore.getBalancesViewerConfig().displaySick) {
                this._loadBalances();
            }
        }
        else if (_.isEmpty(config["users"])) {
            new ViewTTPage.NoUsersWarning($("#viewTTUsersSelectorWarning")).init();
        }
        else if (ViewTTStore.getSelectedUserId() == -1) {
            new ViewTTPage.UserIsNotSelectedWarning($("#viewTTUsersSelectorWarning")).init();
        }
        $(document).trigger("viewTT.init");

        return this;
    }

    _initViewTTPageComponents() {
        // need to be careful in event subscription order, we don`t need to reload data here
        // we just fill dateRange config with not null values for dateFrom and dateTo
        ViewTTStore.setDateRangeConfig(new FilterController().init().getDateRange());
        ViewTTStore.backupDataConfig();

        new ViewTTPage.Totals($("#viewTTTotals")).init();

        new ViewTTPage.PrintableHeader($("#viewTTPrintHeaderContainer")).init();

        this.detailsTable = new DetailsTable().init($("#viewTTDetailsTableContainer"));

        this.chartController = new ViewTTPage.ChartController().init();

        if (!isOldIE()) // IE8 and IE9 don't support pdf preview and pdf generate
        {
            this.pdfGenerator = new PDFGenerator().init();
            //TODO need to remove init parameters (take it from viewttstore into component)
            this.pdfPreviewLightbox = new ViewTTPage.PDFPreviewLightbox().init({
                popupId: "viewTTPdfPreviewLightbox",
                closeBtnId: "closeViewTTPdfPreviewLightboxButton"
            });
        }

        this.balancesViewerController = new ViewTTPage.BalancesViewerController($("#balancesViewerPlaceholder")).init();
        ViewTTStore.setBalancesViewerDate(this.balancesViewerController.getViewerDate());

        new EditTaskPanelContainer({
            onTaskDeletedCb: () => this.loadData(),
        }).init()

        this.page.showPageComponents();

        this._componentesInitialized = true;
    }

    _initUsersSelector() {
        if (ViewTTStore.isNeedToRenderUsersSelector()) {
            var usersSelector = new ViewTTPage.UsersSelector();
            usersSelector.init(ViewTTStore.getUsers(), ViewTTStore.getGroups(), ViewTTStore.getSelectedUserId());
        }
    }

    _loadBalances() {
        var balancesViewerDate = this.balancesViewerController.getViewerDate();
        var selectedUserId = ViewTTStore.getSelectedUserId();
        this.balancesViewerController.spin();
        this._abortRpcCall(this._balanceRpc);
        var self = this;
        this._balanceRpc = makeRpcCall(
            "BalancesViewerService.getBalancesForDate",
            [selectedUserId, balancesViewerDate],
            function(data) {
                ViewTTStore.setBalancesViewerDate(balancesViewerDate);
                ViewTTStore.setBalancesData(data);
            },
            function(jqXHR, textStatus) {
                // we update date even if rpc was aborted,
                self.balancesViewerController.setDate(ViewTTStore.getBalancesViewerDate());

                if (textStatus == "abort") {
                    return true;
                }

                // update balances to remove spinner
                // on abort update will be made in _restoreBalancesForSelectedUserIfNeeded or in next _balanceRpc
                ViewTTStore.setBalancesData(ViewTTStore.getBalancesData());
            }
        );
    }

    _loadViewTTDataAndBalances() {
        $(document).trigger("viewTT.beginLoadData");
        var dataRangeConfig = ViewTTStore.getDateRangeConfig();
        var userId = ViewTTStore.getSelectedUserId();
        var dateRangeQualifier = dataRangeConfig.qualifier;
        var fromDate = dataRangeConfig.fromDate;
        var toDate = dataRangeConfig.toDate;

        var filter = ViewTTStore.getFilter();
        var cpSelection = filter.cpSelection;
        var selectionQualifier = cpSelection.qualifier;
        var customers = cpSelection.customers;
        var projects = cpSelection.projects;
        var showArchivedProjects = cpSelection.showArchivedProjects;

        var balancesViewerDate = null;
        if (this._componentesInitialized) {
            balancesViewerDate = this.balancesViewerController.getViewerDate();
            if (ViewTTPageUtils.isFeatureEnabled(Features["PTO"]) || ViewTTPageUtils.isFeatureEnabled(Features["SDB"])) {
                this.balancesViewerController.spin();
            }
        }

        var self = this;
        this._abortRpcCall(this._dataRpc);
        this._abortRpcCall(this._balanceRpc);
        this._abortRpcCall(this._dataAndBalanceRpc);

        this._dataAndBalanceRpc = makeRpcCall(
            "ViewTTFacadeService.getViewTTDataAndBalances",
            [
                userId, dateRangeQualifier, fromDate, toDate, selectionQualifier, customers,
                projects, !!showArchivedProjects, filter.weekApprovalStatuses, balancesViewerDate
            ],
            function(viewTTDataAndBalances) {
                if (!self._validateLeaveTypeConsistency(viewTTDataAndBalances.viewTTData))
                    return;
                self._prepareAndSetServerData(viewTTDataAndBalances.viewTTData);
                var newBalanceViewerConfig = {
                    hireDate: viewTTDataAndBalances.userWorkScheduleData.hireDate,
                    releaseDate: viewTTDataAndBalances.userWorkScheduleData.releaseDate,
                    initialSchedule: viewTTDataAndBalances.userWorkScheduleData.initialSchedule,
                    schedules: viewTTDataAndBalances.userWorkScheduleData.schedules,
                    displayPto: viewTTDataAndBalances.userBalances.displayPto,
                    displaySick: viewTTDataAndBalances.userBalances.displaySick
                };
                ViewTTStore.setBalancesViewerConfig(newBalanceViewerConfig);
                if (!self._componentesInitialized) {
                    self._initViewTTPageComponents();
                }
                ViewTTStore.setBalancesData(viewTTDataAndBalances.userBalances);

                if (_.isNull(balancesViewerDate))
                    balancesViewerDate = currentUserTime().clearTime(); //today
                if (newBalanceViewerConfig.releaseDate) {
                    var releaseDate = Date.parseJSONDate(newBalanceViewerConfig.releaseDate);
                    if (balancesViewerDate > releaseDate)
                        balancesViewerDate = releaseDate;
                }
                var hireDate = Date.parseJSONDate(newBalanceViewerConfig.hireDate);
                if (balancesViewerDate < hireDate)
                    balancesViewerDate = hireDate;
                ViewTTStore.setBalancesViewerDate(balancesViewerDate);
                self.balancesViewerController.setDate(balancesViewerDate);

                $(document).trigger("viewTT.endLoadData");
            },
            function(jqXHR, textStatus, errorThrown) {
                if (self._componentesInitialized) {
                    self.balancesViewerController.setDate(ViewTTStore.getBalancesViewerDate());
                }

                if (textStatus == "abort") {
                    return true;
                }

                if (textStatus == "rpc_customException") {
                    if (self._handleCustomException(errorThrown.exception))
                        return true;
                }

                ViewTTStore.restoreDataConfig();
                ViewTTStore.setBalancesData(ViewTTStore.getBalancesData());

                $(document).trigger("viewTT.endLoadData");

                return false;
            }
        );
    }

    _needToShowBalances() {
        return ViewTTStore.getBalancesViewerConfig().displayPto || ViewTTStore.getBalancesViewerConfig().displaySick;
    }

    _restoreBalancesForSelectedUserIfNeeded() {
        if (this._componentesInitialized && !_.isNull(ViewTTStore.getData())) {
            this._abortRpcCall(this._balanceRpc);

            // todo: check restore behaviour
            if (this._needToShowBalances()) {
                ViewTTStore.setBalancesData(ViewTTStore.getBalancesData());
            }
            else {
                this.balancesViewerController.hide();
            }
        }
    }

    /**
     * Subscribe for all page events that can change page state
     * @private
     */
    _subscribeForPageEvents() {
        var self = this;

        if (!isOldIE()) // IE8 and IE9 don't support pdf preview and pdf generate
        {
            $(document).on("viewTT.showPDFPreview", function() {
                self.pdfPreviewLightbox.show();
            });
            $(document).on("viewTT.downloadPDF", function() {
                self._saveDisplaySettings();
                downloadPDF(ViewTTStore.getGeneratedPDF(), ViewTTStore.getPDFFileName());
            });
            $(document).on("viewTT.pdfPreview.printParametersForSaveChange", function(event, printParametersForSave) {
                ViewTTStore.setPrintParametersForSave(printParametersForSave);
            });
            $(document).on("viewTT.pdfPreview.printParametersForGenerateChange", function(event, printParametersForGenerate) {
                ViewTTStore.setPrintParametersForGenerate(printParametersForGenerate);
                self.cancelAllExportingProcesses();
                self.generatePDF();
            });
            $(document).on("viewTT.pdfPreview.lightbox.hide", function() {
                self.cancelAllExportingProcesses();
            });
        }
        $(document).on("viewTT.detailsTable.configPanel.change", function(e, detailsTableConfig) {
            ViewTTStore.setDetailsTableConfig(detailsTableConfig);
            self._saveDisplaySettings();
        });
        $(document).on("viewTT.chartSection.change", function(e, chartSectionConfig) {
            ViewTTStore.setChartSectionConfig(chartSectionConfig);
            self._saveDisplaySettings();
        });

        $(document).on("viewTT.dateRangeChange", function(e, dateRangeConfig) {
            ViewTTStore.setDateRangeConfig(dateRangeConfig);
            self.loadData();
        });

        $(document).on("viewTT.filterChange", function(e, filter) {
            ViewTTStore.setFilter(filter);
            self.loadData();
        });

        $(document).on("viewTT.selectedUserChange", function(e, userId) {
            ViewTTStore.setSelectedUserId(userId);
            self._loadViewTTDataAndBalances();
        });

        $(ViewTTStore).on("dataConfigRestored", function() {
            self._restoreBalancesForSelectedUserIfNeeded();
        });

        $(document).on("viewTT.balancesViewerDateChange", function() {
            self._loadBalances();
        });

        $(document).on("viewTT.detailsTable.taskClick", function(e, clickEvent, taskId) {
            setEventPreventHidingEditTaskSlidingPanel(clickEvent)
            self.actions.openTaskPanel(taskId)
        })

        $(document).on('editTaskPanel_updateTask', (e, {taskId, prevTaskState}) => {
            this._onTaskChanged(taskId, prevTaskState)
        })
    }

    loadData() {
        $(document).trigger("viewTT.beginLoadData");
        var dataRangeConfig = ViewTTStore.getDateRangeConfig();
        var userId = ViewTTStore.getSelectedUserId();
        var dateRangeQualifier = dataRangeConfig.qualifier;
        var fromDate = dataRangeConfig.fromDate;
        var toDate = dataRangeConfig.toDate;

        var filter = ViewTTStore.getFilter();
        var cpSelection = filter.cpSelection;
        var selectionQualifier = cpSelection.qualifier;
        var customers = cpSelection.customers;
        var projects = cpSelection.projects;
        var showArchivedProjects = cpSelection.showArchivedProjects;


        var self = this;
        this._abortRpcCall(this._dataRpc);
        this._dataRpc = makeRpcCall("ViewTimeTrackService.getViewTTData",
            [userId, dateRangeQualifier, fromDate, toDate, selectionQualifier, customers, projects, !!showArchivedProjects, filter.weekApprovalStatuses],
            function(data) {
                if (!self._validateLeaveTypeConsistency(data))
                    return;
                self._prepareAndSetServerData(data);
                if (!self._componentesInitialized) {
                    self._initViewTTPageComponents();
                }
                $(document).trigger("viewTT.endLoadData");
            },
            function(jqXHR, textStatus, errorThrown) {
                if (textStatus == "abort") {
                    return true;
                }

                if (textStatus == "rpc_customException") {
                    if (self._handleCustomException(errorThrown.exception))
                        return true;
                }

                ViewTTStore.restoreDataConfig();
                $(document).trigger("viewTT.endLoadData");

                return false;
            });

    }

    _showAlertAndReloadPage(msgKey) {
        alert(messageResource.getMessage(msgKey));
        window.location.reload();
        return true;
    }

    _handleCustomException(exception) {
        if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$NoRightsSubmitMyTTException') {
            return this._showAlertAndReloadPage("view_tt.reload_alert.no_rights.submit_my_tt");
        }

        if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$NoRightsSubmitOtherUserTTException') {
            return this._showAlertAndReloadPage("view_tt.reload_alert.no_rights.submit_other_tt");
        }

        if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserIsDisabledException') {
            return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.disabled");
        }

        if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserIsDeletedException') {
            return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.deleted");
        }

        if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserNotVisibleToManagerException') {
            return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.not_visible");
        }

        return false;
    }

    /*
     Set initial page settings to ViewTTStore
     */
    _setInitialSettings(config) {
        // used in _prepareAndSetServerData
        ViewTTStore.setAssignedCPList(config.assignedCPList);
        ViewTTStore.setAssignedCPMaps({
            customersById: arrayToMapById(config.assignedCPList.customers),
            projectsById: arrayToMapById(config.assignedCPList.projects)
        });
        ViewTTStore.setWeekStartDay(SystemSettings.weekStartDay - 1);
        ViewTTStore.setViewerId(config["viewerId"]);
        ViewTTStore.setUsersAndGroups(config["users"], config["groups"]);
        ViewTTStore.setNeedToRenderUsersSelector(config["needToRenderUsersSelector"]);
        ViewTTStore.setDateFormat(new DateFormat("MMM dd, EEE"));
        var displaySetting = config["displaySettings"];
        ViewTTStore.setDetailsTableConfig(
            {
                viewByDays: displaySetting["tableSortOptions"] == ViewTTTableSortOptions.BY_DAYS,
                asc: displaySetting["tableAsc"],
                showTasks: displaySetting["showTasks"]
            }
        );
        ViewTTStore.setChartSectionConfig(
            {
                chartType: displaySetting["chartType"],
                showChart: displaySetting["showChart"]
            }
        );
        ViewTTStore.setPrintParametersForSave(
            {
                paperSize: displaySetting["pdfPaperSize"],
                paperOrientation: displaySetting["pdfPaperOrientation"],
                showHeaderOnEachPage: displaySetting["pdfShowHeaderOnEachPage"],
                showLogoInHeader: displaySetting["pdfShowLogoInHeader"],
                showSignature: displaySetting["pdfShowSignature"],
                showSignatureOnEachPage: displaySetting["pdfShowSignatureOnEachPage"]
            }
        );
        var pageSettings = config["pageSettings"];

        ViewTTStore.setSelectedUserId(pageSettings["selectedUserId"]);
        //TODO need to handle situation when TIME TRACK APPROVAL FEATURE OFF
        var weekApprovalStatuses = pageSettings["weekApprovalStatuses"];

        ViewTTStore.setFilter({
            weekApprovalStatuses: weekApprovalStatuses,
            cpSelection: pageSettings["customersProjectsSelection"]
        });

        ViewTTStore.setDateRangeConfig(FilterController.parseDateRangeConfig(
            {
                qualifier: pageSettings["dateRangeQualifier"],
                fromDate: pageSettings["dateFrom"],
                toDate: pageSettings["dateTo"]
            }));
        ViewTTStore.setBalancesData(_.isNull(config.balancesViewerConfig) ?
                                    null :
            {
                displayPto: config.balancesViewerConfig.displayPto,
                displaySick: config.balancesViewerConfig.displaySick,
                balances: {PTOBalances: 0, sickBalances: 0}
            }
        );
        ViewTTStore.setBalancesViewerConfig(config.balancesViewerConfig);
        ViewTTStore.setFormatterConfig(config.formatterConfig);
    }

    /*
     Send display settings to server for save
     */
    _saveDisplaySettings() {
        var detailsTableConfig = ViewTTStore.getDetailsTableConfig();
        var chartSectionConfig = ViewTTStore.getChartSectionConfig();
        var pdfPrintParameters = ViewTTStore.getPrintParametersForSave();
        var displaySettings = {
            tableSortOptions: detailsTableConfig["viewByDays"] ? ViewTTTableSortOptions.BY_DAYS : ViewTTTableSortOptions.BY_HIERARCHY,
            tableAsc: detailsTableConfig["asc"],
            showTasks: detailsTableConfig["showTasks"],
            chartType: chartSectionConfig["chartType"],
            showChart: chartSectionConfig["showChart"],
            pdfPaperSize: pdfPrintParameters["paperSize"],
            pdfPaperOrientation: pdfPrintParameters["paperOrientation"],
            pdfShowHeaderOnEachPage: pdfPrintParameters["showHeaderOnEachPage"],
            pdfShowLogoInHeader: pdfPrintParameters["showLogoInHeader"],
            pdfShowSignature: pdfPrintParameters["showSignature"],
            pdfShowSignatureOnEachPage: pdfPrintParameters["showSignatureOnEachPage"]
        };
        makeRpcCall("ViewTimeTrackService.saveDisplaySettings", [displaySettings], function() {}, function() {return true;});
    }

    /*
     Check if we know all leave types
     */
    _validateLeaveTypeConsistency(serverData) {
        var daysInfo = serverData["daysInfoData"];
        return _.every(daysInfo, function(dayinfo) {
            return LeaveTypeUtil.validateLeaveType(dayinfo["leave"]);
        })
    }

    /*
     Convert server data to convenient form
     */
    _prepareAndSetServerData(serverData) {
        ViewTTStore.backupDataConfig();
        // convert date offset to date fields
        var nextDate = Date.parseJSONDate(serverData["dateFrom"]);
        for (var i = 0; i < serverData["daysInfoData"].length; i++) {
            serverData["daysInfoData"][i]["date"] = nextDate.getNDaysAfter(i);
        }

        var userInfo = {
            "today": Date.parseJSONDate(serverData["userInfo"]["today"]),
            "hireDate": Date.parseJSONDate(serverData["userInfo"]["hireDate"]),
            "autoApproved": serverData["userInfo"]["autoApproved"]
        };
        ViewTTStore.setUserInfo(userInfo);

        var cptMaps = {
            customersById: arrayToMapById(serverData.customers),
            projectsById: arrayToMapById(serverData.projects),
            tasksById: arrayToMapById(serverData.tasks)
        };
        ViewTTPageUtils.updateCPList(ViewTTStore.getAssignedCPList(), cptMaps);

        // features must be set before the data, or we dispatch them with old features
        // same goes for mergedCp
        ViewTTStore.setEnabledFeatures(serverData.enabledFeatures);
        var mergedCp = ViewTTPageUtils.mergeCPLists(ViewTTStore.getAssignedCPMaps(),
            ViewTTStore.getAssignedCPList(),
            {
                customers: serverData.customers,
                projects: serverData.projects
            });
        ViewTTStore.setMergedCp(mergedCp);
        ViewTTStore.setData(serverData, cptMaps);
    }

    generatePDF() {
        $(document).trigger("viewTT.pdfGenerator.start");
        var self = this;
        this.pdfGenerator.generatePDF(
            function(config, onDataProvided) {
                self.chartController.exportChart(config["chartImageSizes"], function(img) {
                    onDataProvided({
                        chartImage: img
                    });
                });
            }
        ).then(
            function(pdf) {
                ViewTTStore.setGeneratedPDF(pdf.encodedPDF);
                ViewTTStore.setPDFFileName(pdf.fileName);
            },
            function(error) {
                if (error.message != "abort") {
                    console.error(error);
                }
            });
    }

    cancelAllExportingProcesses() {
        this.pdfGenerator.interruptGeneration();
        this.pdfPreviewLightbox.cancelAllExportingProcesses();
    }

    _onTaskChanged(taskId, prevTaskState){
        var task = TaskStore.get(taskId);
        if (!task || !prevTaskState)
            return

        if (taskId !== prevTaskState.id)
            return

        var currWorkflowStatus = this.state.workflowStatuses[selectStatusIdByTask(task)];
        var prevWorkflowStatus = this.state.workflowStatuses[selectStatusIdByTask(prevTaskState)];

        var curTaskProject = ViewTTStore.getProject(task.projectId)
        var curTaskCustomer = ViewTTStore.getCustomer(task.customerId)

        if (prevTaskState.name !== task.name || (!!prevWorkflowStatus && prevWorkflowStatus.colorId !== currWorkflowStatus.colorId)
            || prevTaskState.commentsNumber !== task.commentsNumber
            || !prevTaskState.description && task.description || prevTaskState.description !== task.description
            || (!!curTaskCustomer && curTaskCustomer.name !== prevTaskState.customerName)
            || (!!curTaskProject && curTaskProject.name !== prevTaskState.projectName)) {
            ViewTTStore.updateTask(task)
            this.detailsTable.update()
        }
    }

    _abortRpcCall(rpc) {
        if (!_.isUndefined(rpc)) {
            rpc.abort();
        }
    }
};

export default connect(
    state => ({
        workflowStatuses: getWorkflowStatuses(state),
        openTaskId: getOpenTaskId(state)
    }),
    dispatch => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
    })
)(ViewTTMediator)


// WEBPACK FOOTER //
// ./web/js/user/viewtt/ViewTTMediator.js